import Splide from '@splidejs/splide';

import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom'
import lgThumbnail from 'lightgallery/plugins/thumbnail'

class ImageSlider {
    constructor(node, index) {
        let self = this;
        self.sliderNode = node;
        self.index = index;
        self.galleryNode = self.sliderNode.querySelector('.js-image-slider-gallery');

        self.build();
    }

    build() {
        let self = this;
        self._createSlider();

        if (self.galleryNode) {
            self._createGallery();
        }
    }

    destroyAll() {
        let self = this;

        if (self.slider) {
            self.destroySlider();
            self._destroyButtonsEvent();
        }

        if (self.gallery) {
            setTimeout(() =>{
                self.gallery = null;
                self.index = null;
            }, self.destroyGallery());
        }

        self.slider = null;

        self.sliderNode = null;
    }

    destroySlider() {
        let self = this;
        self._destroyButtonsEvent();
        self.slider.destroy(true);
        self.slider = null;
        self.sliderNode = null;
    }

    destroyGallery() {
        let self = this;
        return self.gallery.destroy();
    }

    goTo(index) {
        let self = this;
        self.slider.go(index);
    }

    openGallery (index) {
        let self = this;
        self.gallery.openGallery(index);
    }

    nextSlide(self) {
        self.slider.go('>')
    }

    prevSlide(self) {
        self.slider.go('<')
    }

    _createSlider() {
        let self = this;
        self.slider = new Splide(self.sliderNode, {
            type: 'slide',
            perPage: 1,
            clones: 0,
            arrows: false,
            pagination: false,
            breakpoints: {
                768: {
                    pagination: true,
                }
            }

        }).mount();

        self._navigation();
        self._initClickEvent();
    }

    _createGallery() {
        let self = this;
        if (self.galleryNode) {
            self.gallery = lightGallery(self.galleryNode, {
                download: false,
                preload: 1,
                plugins: [lgZoom, lgThumbnail]
            });
        }
    }

    _initClickEvent() {
        let self = this;

        self.nextButton = self.sliderNode.querySelector('.c-slider__nav-next');
        self.prevButton = self.sliderNode.querySelector('.c-slider__nav-prev');

        self.fakePrevButton  = self.sliderNode.querySelector('.c-slider__fake-nav--left');
        self.fakeNextButton  = self.sliderNode.querySelector('.c-slider__fake-nav--right');

        if (self.nextButton) {
            self.nextButtonReference = self.nextSlide.bind(null, self);
            self.nextButton.addEventListener('click', self.nextButtonReference, false);
        }

        if (self.prevButton) {
            self.prevButtonReference = self.prevSlide.bind(null, self);
            self.prevButton.addEventListener('click', self.prevButtonReference, false);
        }

        if (self.fakePrevButton) {
            self.fakePrevButton.addEventListener('click', self.prevSlide, false);
        }

        if (self.fakeNextButton) {
            self.fakeNextButton.addEventListener('click', self.nextSlide, false);
        }
    }

    _destroyButtonsEvent() {
        let self = this;

        if(self.nextButton && self.prevButton) {
            self.nextButton.removeEventListener('click', self.nextSlide, false);
            self.prevButton.removeEventListener('click', self.prevSlide, false);
        }

        if(self.fakeNextButton && self.fakePrevButton) {
            self.fakePrevButton.removeEventListener('click', self.nextSlide, false);
            self.fakeNextButton.removeEventListener('click', self.prevSlide, false);
        }

        self.nextButton = null;
        self.prevButton = null;
        self.fakeNextButton = null;
        self.fakePrevButton = null;
    }

    _navigation() {
        let self = this;

        if (window.innerWidth < 768) {
            return;
        }

        let navigationWrapper = self.sliderNode.parentElement.querySelector('.c-image-slider-nav');

        let navigationItems = navigationWrapper.querySelectorAll('.c-image-slider-nav__item');

        if (navigationItems.length >= 1) {
            navigationItems.forEach(function (item, index) {
                if (navigationWrapper.closest('.c-product-detail__slider')) {
                    if (index >= 6 && navigationItems.length - 1 === index) {
                        item.setAttribute('onclick', `window.imageSlider.sliderObjects[${self.index}].openGallery(${index});`);
                        item.dataset.count = self.slider.length - index;
                        return;
                    }
                }
                else {
                    if (index >= 3 && navigationItems.length - 1 === index) {
                        item.setAttribute('onclick', `window.imageSlider.sliderObjects[${self.index}].openGallery(${index});`);
                        item.dataset.count = self.slider.length - index;
                        return;
                    }
                }


                item.setAttribute('onclick', `window.imageSlider.sliderObjects[${self.index}].goTo(${index})`);
            });
        }
    }
}

const imageSlider = {
    sliderObjects: [],

    init() {
        let self = this;
        let sliderNodes = document.querySelectorAll('.js-image-slider');

        if (! sliderNodes.length) {
            return;
        }


        sliderNodes.forEach((sliderNode, index) => {
             self.sliderObjects[index] = new ImageSlider(sliderNode, index);
        });

    },

    reInit() {
        let self = this;
        let timeout = 1;

        if (self.sliderObjects.length) {
            self.sliderObjects.forEach(sliderObject => {
                sliderObject.destroySlider();
                let currentTimeout = sliderObject.destroyGallery();
                if (currentTimeout > timeout) {
                    timeout = currentTimeout;
                }

                setTimeout(() => {
                    sliderObject.gallery = null;
                    sliderObject.index = null;
                }, currentTimeout);
            });
        }

        setTimeout(() => {
            self.sliderObjects = [];
            self.init();
        }, timeout);
    }
};


window.imageSlider = imageSlider;
window.imageSlider.init();

document.addEventListener('LokiRequestEnd', function () {
    window.imageSlider.reInit();
});